import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import Clock from '../../../static/svg/clock.svg';
import { getFormattedDate } from '../../utils/dateLib';

const DateWithClock = ({ date, formatDate }) => {
  return (
    <Container className="post-date flex items-center">
      <Clock />
      {formatDate ? getFormattedDate(date) : false}
    </Container>
  );
};

DateWithClock.propTypes = {
  date: PropTypes.string,
  formatDate: PropTypes.bool,
};

DateWithClock.defaultProps = {
  formatDate: true,
};

export default DateWithClock;

const Container = styled.span`
  svg {
    margin-right: 5px;
    width: 12px;
    height: 12px;
  }
`;
